import { http } from "@/http";

export const setStudyEnabled = async(id:string, enabled:boolean) => {
	await http.patch(`studies/${id}`, { enabled });
};